import { BuildInfo } from '../../constants/buildInfo.constant'
import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class IntercomConfigService {

    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    config(): void {
        // @ts-ignore
        var ic = window.Intercom
        if (typeof ic === 'function') {
            ic('reattach_activator')
        } else {
            var i: any = function() {
                i.c(arguments)
            }
            i.q = []
            i.c = function(args): void {
                i.q.push(args)
            }
            // @ts-ignore
            window.Intercom = i
        }

        this.addScript(this.document)
    }

    private addScript(document: Document): void {
        var s = document.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = 'https://widget.intercom.io/widget/' + BuildInfo.intercomAppId
        var x = document.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
    }
}